import { ref, readonly } from 'vue'

/**
 * Global route-transition busy flag for sidebar / in-app navigations.
 * Set from the router; read from AppLayout for the top progress indicator.
 */
const isNavigating = ref(false)
const showBusyIndicator = ref(false)

let showDelayTimer: ReturnType<typeof setTimeout> | undefined
/** Delay before showing the bar so instant (cached) navigations do not flash. */
const SHOW_DELAY_MS = 80

export function startRouteNavigationBusy() {
  isNavigating.value = true
  if (showDelayTimer !== undefined) {
    clearTimeout(showDelayTimer)
  }
  showDelayTimer = setTimeout(() => {
    if (isNavigating.value) {
      showBusyIndicator.value = true
    }
    showDelayTimer = undefined
  }, SHOW_DELAY_MS)
}

export function endRouteNavigationBusy() {
  isNavigating.value = false
  showBusyIndicator.value = false
  if (showDelayTimer !== undefined) {
    clearTimeout(showDelayTimer)
    showDelayTimer = undefined
  }
}

export function useRouteNavigationBusy() {
  return {
    isNavigating: readonly(isNavigating),
    showBusyIndicator: readonly(showBusyIndicator),
  }
}
